import React from 'react';
import {
  IconButton, Popover, MenuList, MenuItem, ListItemIcon, ListItemText,
} from '@material-ui/core';
import MoreVert from '@material-ui/icons/MoreVert';
import BugReport from '@material-ui/icons/BugReport';
import LinkIcon from '@material-ui/icons/Link';
import { useEntity } from '@backstage/plugin-catalog-react';
import { MyInspectEntityDialog } from './MyInspectEntityDialog';

export const MyEntityContextMenu = () => {
  const { entity } = useEntity();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [inspectOpen, setInspectOpen] = React.useState(false);

  const onCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setAnchorEl(null);
    } catch (err) {
      console.error('Failed to copy URL: ', err);
      alert('Failed to copy URL. Please try copying manually from the address bar.');
      return;
    }
  };

  return (
    <>
      <IconButton aria-label="more" style={{ color: 'white' }} onClick={e => setAnchorEl(e.currentTarget)}>
        <MoreVert />
      </IconButton>

      <Popover
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuList>
          <MenuItem onClick={() => { setInspectOpen(true); setAnchorEl(null); }}>
            <ListItemIcon><BugReport fontSize="small" /></ListItemIcon>
            <ListItemText primary="Inspect entity" />
          </MenuItem>
          <MenuItem onClick={onCopyUrl}>
            <ListItemIcon><LinkIcon fontSize="small" /></ListItemIcon>
            <ListItemText primary="Copy entity URL" />
          </MenuItem>
        </MenuList>
      </Popover>

      <MyInspectEntityDialog
        open={inspectOpen}
        onClose={() => setInspectOpen(false)}
        entity={entity}
      />
    </>
  );
};